import firmTypes from './firmTypes';

export const pageSizes = {
  '10': 10,
  '20': 20,
  '50': 50,
  '75': 75,
  '100': 100,
  '200': 200,
  '300': 300,
};

export const groupIds = {
  Shipper: 1,
  Carrier: 2,
  Dispatcher: 3,
};

export const groupIdsToFirmTypes = {
  [groupIds.Carrier]: [firmTypes.Carrier],
  [groupIds.Dispatcher]: [firmTypes.Forwarder, firmTypes.Dispatcher, firmTypes.ForwarderCarrier],
  [groupIds.Shipper]: [firmTypes.Shipper, firmTypes.ShipperCarrier],
};

export const paramsDefaults = {
  Skip: 0,
  Take: 20,
  Reverse: false,
  Verified: false,
  Autopark: false,
  AtiOrders: false,
  AtiDocs: false,
  confirmedContacts: false,
  epdMedal: false,
  GeoTypeId: 4,
  GeoId: 1,
  GeoName: 'Россия',
  GroupId: groupIds.Carrier,
  FirmTypes: groupIdsToFirmTypes[groupIds.Carrier],
};

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const skipParamName = 'skip';
export const takeParamName = 'take';
export const geoTypeIdParamName = 'geoTypeId';
export const geoIdParamName = 'geoId';
export const groupIdParamName = 'groupTypeId';
export const atiDocsParamName = 'atiDocs';
export const autoparkParamName = 'autopark';
export const atiOrdersParamName = 'atiOrders';
export const verifiedParamName = 'verified';
export const confirmedContactsParamName = 'confirmedContacts';
export const epdMedalParamName = 'epdMedal';
